export interface ParsedFrontmatter {
    data: Record<string, string>
    body: string
}

const FRONTMATTER_RE = /^---\n([\s\S]*?)\n---\n?([\s\S]*)$/

function stripQuotes(value: string): string {
    const trimmed = value.trim()
    if (trimmed.length >= 2) {
        const first = trimmed[0]
        const last = trimmed[trimmed.length - 1]
        if ((first === '"' || first === "'") && first === last) {
            return trimmed.slice(1, -1)
        }
    }
    return trimmed
}

/**
 * Parse a markdown string with an optional leading YAML-subset frontmatter
 * block. Supports flat `key: value` pairs only (values may be quoted and may
 * themselves contain colons). Nested structures are intentionally unsupported
 * to keep the parser dependency-free; the changelog schema is flat.
 */
export function parseFrontmatter(raw: string): ParsedFrontmatter {
    const normalized = raw.replace(/\r\n/g, '\n')
    const match = normalized.match(FRONTMATTER_RE)
    if (!match) {
        return { data: {}, body: normalized.trim() }
    }

    const [, frontmatter, body] = match
    const data: Record<string, string> = {}
    for (const line of frontmatter.split('\n')) {
        if (!line.trim()) continue
        const sep = line.indexOf(':')
        if (sep === -1) continue
        const key = line.slice(0, sep).trim()
        if (!key) continue
        data[key] = stripQuotes(line.slice(sep + 1))
    }

    return { data, body: body.trim() }
}
